import { render, staticRenderFns } from "./Dismantle.vue?vue&type=template&id=07921508&scoped=true"
import script from "./Dismantle.vue?vue&type=script&lang=js"
export * from "./Dismantle.vue?vue&type=script&lang=js"
import style0 from "./Dismantle.vue?vue&type=style&index=0&id=07921508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07921508",
  null
  
)

export default component.exports